import React, { useState } from "react";
import LogoLayout from "../../../components/logolayout/logolayout";
import SelectInput from "../../../components/form/inputs/select-input/select-input";
import TextInput from "../../../components/form/inputs/text-input/text-input";
import countriesJson from "../../../data/countries.json";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAppContext } from "../../../context/app.context";
import { emailReg, passwordReg, showToast } from "../../../utils/utils";
import CheckBoxInput from "../../../components/form/inputs/check-input/check-input";
import Modal from "../../../components/modal/modal";
import axiosInstance from "../../../config/axios";
interface RegisterSignupPageProps {
  formData?: any;
  onNext?: (data: any) => void;
  onBack?: () => void;
}

export default function RegisterStep3Page({ formData, onNext, onBack }: RegisterSignupPageProps) {
  const [search, setSearch] = useState("");
  const [showmodal, setshowmodal] = useState(false);
  const navigate = useNavigate();
  const { state } = useLocation();
  const [checked, setchecked] = useState(false);
  const passwordRules = [
    "Plus de 8 caractères",
    "Au minimum une majuscule et une minuscule",
    "Doit contenir un chiffre et un caractère spécial",
  ];

  const { appInfos, setAppInfos } = useAppContext();
  async function onSubmit(form: any) {
    // await axiosInstance.post(`auth/signup/checkemail`, { ...form, ...state });
    navigate("/register/step4", { state: { ...form, ...state } });
    setAppInfos({ formState: { ...form, ...state } });
  }
  if (!state || (state && Object.keys(state).length == 0)) return <Navigate replace to="/register" />;
  return (
    <LogoLayout onSubmit={onSubmit} submitTitle="Suivant" progress={60} hideBack={true}>
      <div className="d-flex flex-grow-1 flex-column">
        <TextInput
          name="password"
          autocomplete="new-password"
          showPassword
          value={appInfos.formState?.password}
          type="password"
          placeHolder="Ton mot de passe"
          label="Mot de passe"
          helper={passwordRules}
          error={passwordRules}
          validate={(val: any) => (!passwordReg.test(val) ? "Mot de passe invalide" : true)}
        />
        <TextInput
          autocomplete="new-password"
          name="confirm"
          value={appInfos.formState?.confirm}
          showPassword
          type="password"
          placeHolder="Confirmer ton mot de passe"
          label="Confirmation mot de passe"
          validate={(val: any, form: any) =>
            !val || val !== form.password ? "Les mots de passe ne correspondent pas" : true
          }
        />
      </div>
    </LogoLayout>
  );
}
